import GovDescriptionRenderer, { govDescriptionRendererTester } from './GovDescription'
import GovLabelRenderer, { govLabelRendererTester } from './GovLabel'
import GovSectionTitleRenderer, { govSectionTitleRendererTester } from './GovSectionTitle'

export const rederersVisual = [
  { renderer: GovLabelRenderer, tester: govLabelRendererTester },
  { renderer: GovDescriptionRenderer, tester: govDescriptionRendererTester },
  { renderer: GovSectionTitleRenderer, tester: govSectionTitleRendererTester },
]
